export default __webpack_public_path__ + "static/media/promoDown.e48f5b69.png";